import { db } from '../firebase';
import { collection, addDoc, query, orderBy, limit, onSnapshot, serverTimestamp, getDocs, deleteDoc, doc } from 'firebase/firestore';

/**
 * Sends a chat message to a specific stream.
 */
export const sendChatMessage = async (streamId, user, text) => {
    if (!streamId || !user || !text.trim()) return;

    try {
        const messagesRef = collection(db, 'activeStreams', streamId, 'messages');
        await addDoc(messagesRef, {
            text: text.trim(),
            userId: user.uid,
            userName: user.name || 'Anonymous',
            photoURL: user.photoURL || null,
            createdAt: serverTimestamp(),
            type: 'text' // extensible for 'gift', 'system', etc.
        });
    } catch (error) {
        console.error("Error sending message:", error);
    }
};

/**
 * Sends a notification that a user has joined the stream.
 */
export const sendJoinMessage = async (streamId, user) => {
    if (!streamId || !user) return;

    try {
        const messagesRef = collection(db, 'activeStreams', streamId, 'messages');
        await addDoc(messagesRef, {
            text: `${user.name || 'A user'} joined`,
            userId: user.uid,
            userName: user.name || 'Anonymous',
            createdAt: serverTimestamp(),
            type: 'join'
        });
    } catch (error) {
        console.error("Error sending join message:", error);
    }
};

/**
 * Listens to chat messages for a specific stream.
 * Returns an unsubscribe function.
 */
export const listenToChatMessages = (streamId, callback) => {
    if (!streamId) return () => { };

    const messagesRef = collection(db, 'activeStreams', streamId, 'messages');
    const q = query(messagesRef, orderBy('createdAt', 'asc'), limit(100));

    return onSnapshot(q, (snapshot) => {
        const messages = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        callback(messages);
    });
};

/**
 * Deletes all chat messages for a specific stream.
 */
export const clearChatMessages = async (streamId) => {
    if (!streamId) return;

    try {
        const messagesRef = collection(db, 'activeStreams', streamId, 'messages');
        const snapshot = await getDocs(messagesRef);

        const deletePromises = snapshot.docs.map(docSnapshot =>
            deleteDoc(doc(db, 'activeStreams', streamId, 'messages', docSnapshot.id))
        );

        await Promise.all(deletePromises);
        console.log(`Cleared ${snapshot.size} messages for stream ${streamId}`);
    } catch (error) {
        console.error("Error clearing chat messages:", error);
    }
};
